import { InitialState } from "./type";

export const initialState: InitialState = {
  favouriteList: [],
  cardList: [],
  priceList: {},
};
